import React from 'react';
import PropTypes from 'prop-types';

import { Cintillo, LoadingPlaceholder } from 'components';
import { useContextResultOrigin } from 'contexts/resultOrigin';
import { useContextMatchParams } from 'contexts/matchParams';
import useManualPages from 'dataProvider/hooks/useManualPages';

import MasterBarGeneral from '../../components/masterBar/masterBarGeneral';

import TownGeneral from './townGeneral';
import MainGeneral from './main';

import './home.scss';

import useResultProvider from '../../dataProvider/hooks/useResultProvider';
import useGetPlace from '../../dataProvider/hooks/useGetPlace';

import { NAVIGATION_MODE } from '../../constants';
import { getSite, isLaRazon } from '../../constants/sites';

const site = getSite();

const HomeGeneral = ({ history }) => {
  const { matchParams } = useContextMatchParams();
  const {
    allMap: allMapParams,
    chartType,
    community,
    country,
    electionNumber,
    navigableMode,
    province,
    showMasterBar,
    town,
    type,
    subtype,
    year
  } = matchParams;

  const allMap = Boolean(Number(allMapParams));

  const resultOrigin = useContextResultOrigin();

  const { result: dataResult } = useResultProvider({
    active: resultOrigin.primary?.active,
    year,
    type,
    subtype,
    electionPlace: country,
    electionNumber,
    placeId: town || province || community,
    details: Boolean(town),
    site
  });

  const { result: oldData } = useResultProvider({
    active: false /* buscame */,
    old: true,
    year: resultOrigin?.historic?.year,
    type,
    subtype,
    electionPlace: country,
    electionNumber: resultOrigin?.historic?.numElection,
    placeId: town || province || community
  });

  const manualUrls = useManualPages({ regionId: country });

  console.log('manualUrls', manualUrls);
  const homeUrl = manualUrls?.[country];

  const selectedPlace = useGetPlace(town || province || community, type);
  const selectedCommunity = useGetPlace(community, type);

  const onChangeLocation = (e, place, fromMap, fromSelect) => {
    const isL = isLaRazon(site);

    if (
      ((parseInt(navigableMode, 10) === NAVIGATION_MODE.INTERNAL ||
        (allMap && fromMap)) &&
        !isL) ||
      place.typePlace === 'COUNTRY'
    ) {
      e.preventDefault();
      switch (place.typePlace) {
        case 'COUNTRY':
          history.push(
            `/${country}/${navigableMode}/${year}/GENERAL/${subtype}/${electionNumber}/${chartType}/${showMasterBar}/1/${place.ineId}/home-generales-resultados.html`
          );
          break;
        case 'PROVINCE':
          if (allMap && !fromSelect) {
            history.push(
              `/${country}/${navigableMode}/${year}/GENERAL/${subtype}/${electionNumber}/${chartType}/${showMasterBar}/0/${place.parentId}/home-generales-resultados.html`
            );
          } else {
            history.push(
              `/${country}/${navigableMode}/${year}/GENERAL/${subtype}/${electionNumber}/${chartType}/${showMasterBar}/0/${place.parentId}/${place.ineId}/home-generales-resultados.html`
            );
          }
          break;
        case 'TOWN':
          history.push(
            `/${country}/${navigableMode}/${year}/GENERAL/${subtype}/${electionNumber}/${chartType}/${showMasterBar}/0/${place.grandpaId}/${place.parentId}/${place.ineId}/home-generales-resultados.html`
          );
          break;
        case 'REGION':
          history.push(
            `/${country}/${navigableMode}/${year}/GENERAL/${subtype}/${electionNumber}/${chartType}/${showMasterBar}/0/${place.ineId}/home-generales-resultados.html`
          );
          break;
        default:
          // go to home
          break;
      }
    }
  };

  const changeSubtype = (e, newSubtype) => {
    e.preventDefault();
    e.stopPropagation();
    history.push(
      `/${country}/${navigableMode}/${year}/${type}/${newSubtype}/${electionNumber}/${chartType}/${showMasterBar}/${
        allMap ? '1' : '0'
      }${community ? `/${community}` : ''}${province ? `/${province}` : ''}${
        town ? `/${town}` : ''
      }/home-generales-resultados.html`
    );
  };
  if (!dataResult || !oldData || !selectedCommunity || !selectedPlace) {
    return <LoadingPlaceholder />;
  }

  return (
    <div
      className={`mainWrapper pageHome pageHome--regional chart_${chartType}`}
    >
      <div className={`block ${dataResult.currentCountPercent || `empty`}`}>
        <MasterBarGeneral onClick={changeSubtype} />

        <Cintillo
          currentCountPercent={dataResult.currentCountPercent}
          updateDate={dataResult.updateDate}
          withScrutiny
        />
        {town ? (
          <TownGeneral
            dataResult={dataResult}
            oldData={oldData}
            onChangeLocation={onChangeLocation}
            selectedCommunity={selectedCommunity}
            selectedPlace={selectedPlace}
            homeUrl={homeUrl}
          />
        ) : (
          <MainGeneral
            dataResult={dataResult}
            oldData={oldData}
            onChangeLocation={onChangeLocation}
            selectedCommunity={selectedCommunity}
            selectedPlace={selectedPlace}
            homeUrl={homeUrl}
          />
        )}
      </div>
    </div>
  );
};

HomeGeneral.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default HomeGeneral;
